import React from 'react';
import './ToggleSwitch.scss';

const ToggleSwitch = ({ toggled, onToggle }) => {
  const handleToggle = () => {
    onToggle(!toggled); 
  };

  return (
    <span className='switch-box'>
      <label className='switch'>
        <input
          type="checkbox"
          checked={toggled} 
          onChange={handleToggle}
        />
        <span className='slider round'></span>
      </label>      
    </span>
  );
};

export default ToggleSwitch;